import { Box, Container, Typography, Grid, Paper } from "@mui/material";
import React from "react";
import AboutMain from "../component/about/AboutMain";
import FaqSection from "../component/about/FaqSection";
import OfferSection from "../component/about/OfferSection";
import DesSec from "../component/Home/DesSec";

const About = () => {
  return (
    <Container maxWidth="lg" sx={{ py: { xs: 6, md: 8 } }}>
      
      {/* HERO SECTION */}
      <Box textAlign="center" mb={{ xs: 6, md: 8 }}>
        <Typography
          variant="h2"
          fontWeight={800}
          gutterBottom
          color = "primary"
          sx={{
            lineHeight: 1.2,
            letterSpacing: "-0.5px",
          }}
        >
          Reimagining School Management for the Digital Era
        </Typography>

        <Typography
          variant="h6"
          color="text.secondary"
          sx={{
            maxWidth: 750,
            mx: "auto",
            lineHeight: 1.8,
            fontWeight: 400,
          }}
        >
          MySchoolling is a comprehensive digital ecosystem built to empower
          schools, streamline operations, and enhance student learning through
          intelligent technology and seamless communication.
        </Typography>
      </Box>

      {/* SPLIT SECTION */}
      <Grid
        container
        spacing={{ xs: 5, md: 8 }}
        alignItems="center"
        mb={{ xs: 8, md: 10 }}
      >
        <Grid item xs={12} md={6}>
          <Typography variant="h4" fontWeight={600} gutterBottom>
            Built with Intelligence. Designed for Impact.
          </Typography>

          <Typography
            variant="body1"
            sx={{
              lineHeight: 1.85,
              fontSize: "1.05rem",
              color: "text.secondary",
            }}
          >
            Education is evolving rapidly, and institutions require modern
            solutions that adapt to new challenges. MySchoolling combines
            AI-powered learning tools, real-time communication, and
            comprehensive administrative management into one seamless platform.
            <br /><br />
            From academic tracking and performance analytics to transport
            monitoring and parent engagement, we provide schools with clarity,
            control, and confidence to operate efficiently in a connected world.
          </Typography>
        </Grid>

        <Grid item xs={12} md={6}>
          <Box
            component="img"
            src="/about.png"
            alt="MySchoolling Platform"
            sx={{
              width: "100%",
              borderRadius: 4,
              boxShadow: "0 20px 60px rgba(0,0,0,0.07)",
            }}
          />
        </Grid>
      </Grid>

      {/* VISION BLOCK */}
      <Paper
        elevation={0}
        sx={{
          p: { xs: 5, md: 6 },
          borderRadius: 4,
          border: "1px solid rgba(0,0,0,0.06)",
          boxShadow: "0 15px 40px rgba(0,0,0,0.04)",
          mb: { xs: 8, md: 8 },
          textAlign: "center",
        }}
      >
        <Typography
          variant="h4"
          fontWeight={700}
          gutterBottom
        >
          Our Vision
        </Typography>

        <Typography
          variant="body1"
          sx={{
            maxWidth: 850,
            mx: "auto",
            lineHeight: 1.85,
            fontSize: "1.05rem",
            color: "text.secondary",
          }}
        >
          We envision a future where schools operate seamlessly,
          parents stay connected, and students receive personalized
          academic support powered by intelligent insights.
          <br /><br />
          By integrating advanced technology with thoughtful design,
          MySchoolling delivers an enterprise-grade platform that
          supports institutional growth and measurable academic success.
        </Typography>
      </Paper>

      {/* EXISTING COMPONENTS (TIGHTER SPACING) */}
      {/* <Box mb={{ xs: 8, md: 8 }}>
        <AboutMain />
      </Box> */}

      <Box mb={{ xs: 8, md: 8 }}>
        <OfferSection />
      </Box>

      <Box mb={{ xs: 8, md: 0 }}>
        <DesSec />
      </Box>

      <FaqSection />
    </Container>
  );
};

export default About;